<template>
<div v-if="hasPermissionView">
  <div v-if="prestacaoConta.monitoramentoFinanceiro">
    <v-col cols="12" v-if="!editing">
      <v-card tile class="mx-1">
        <v-card-title>
          <p>Relatório de Monitoramento Financeiro</p> 
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="4" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Responsável:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.responsavel.nome }}
              </p>
            </v-col>
            <v-col cols="4" class="mb-n4">
              <span class="font-weight-bold text-uppercase">E-mail:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.responsavel.email }}
              </p>
            </v-col>
            <v-col cols="4" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Parceiro:</span>
              <p class="font-weight-light title">
                {{ prestacaoConta.monitoramentoFinanceiro.organizacao.nome }}
              </p>
            </v-col>
            <v-col cols="12" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Data:</span>
              <p class="font-weight-light title">
                {{ formatarData(prestacaoConta.monitoramentoFinanceiro.data) }}
              </p>
            </v-col>
            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Check list de itens apresentados:</span>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.taxaCambio"
                label="Taxa de câmbio"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.conciliacaoBancaria"
                label="Conciliação Bancária"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.resumoRubrica"
                label="Resumo por rubrica"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.planilhaResumoDespesasEuroEReal"
                label="Planilhas de resumo de despesas (Euro e Reais)"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.documentoComprovanteDespesa"
                label="Documentos comprovantes de despesas"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.planejamentoFinanceiro" 
                label="Planejamento Financeiro"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n6"
                v-model="prestacaoConta.monitoramentoFinanceiro.percentualExecucaoMacroRubrica" 
                label="Percentual de execução de macro rubricas"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n4"
                v-model="prestacaoConta.monitoramentoFinanceiro.folhaDedicacaoPessoal"
                label="Folha de dedicação de Pessoal"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n4"
                v-model="prestacaoConta.monitoramentoFinanceiro.pendenciaMesesAnteriores"
                label="Pendências de meses anteriores"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n4"
                v-model="prestacaoConta.monitoramentoFinanceiro.inventario"
                label="Inventário"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n4"
                v-model="prestacaoConta.monitoramentoFinanceiro.contabilidade"
                label="Contabilidade"
                readonly
              ></v-checkbox>
              <v-checkbox
                class="mb-n4"
                v-model="prestacaoConta.monitoramentoFinanceiro.outros"
                label="Outros"
                readonly
              ></v-checkbox>
              <p v-if="prestacaoConta.monitoramentoFinanceiro.outros" class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.outrosItens }}
              </p>
            </v-col>
            <v-col cols="12" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Ajustes Realizados:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.ajustesRealizados }}
              </p>
            </v-col>
            <v-col cols="12" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Ajustes Solicitados:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.ajustesSolicitados }}
              </p>
            </v-col>
            <v-col cols="12" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Orientações:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.orientacoes }}
              </p>
            </v-col>
            <v-col cols="12" class="mb-n4">
              <span class="font-weight-bold text-uppercase">Observações do Monitoramento:</span>
              <p class="font-weight-light title ">
                {{ prestacaoConta.monitoramentoFinanceiro.observacoesMonitoramento }}
              </p>
            </v-col>
            <v-list class="ml-2" v-if="prestacaoConta.arquivoMonitoramento">
              <v-list-item link>
                  <v-list-item-content class="py-2">
                    <v-list-item-title>{{prestacaoConta.arquivoMonitoramento.name}}</v-list-item-title>
                  </v-list-item-content>
                <v-list-item-action-text>
                  <v-btn @click="downloadItem()" class="ml-6" outlined color="primary">
                    Download <v-icon color="primary lighten-1">mdi-arrow-down-bold-circle-outline</v-icon>
                  </v-btn>
                </v-list-item-action-text>
              </v-list-item>
            </v-list>
            <v-col cols="12" class="mb-n4" v-else>
              <span class="font-weight-bold text-uppercase">Arquivo:</span>
              <p class="font-weight-light title">
                Não há arquivo registrado
              </p>
            </v-col>            
          </v-row>
        </v-card-text>        
        <v-divider></v-divider>

        <v-card-actions v-if="hasPermissionEdit" class="mx-1 py-4">
          <v-btn @click.prevent="editing = true"  color="primary text-center" small>Editar</v-btn>
          <v-btn @click="enviar()" color="info" small>Enviar para manifestação da OSC</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <MonitoramentoEditor v-else
      :prestacaoConta="prestacaoConta"
      @save="editing = false"
      @cancel="editing = false" />
  </div>
  <div v-else>
    <MonitoramentoEditor
      :prestacaoConta="prestacaoConta"
      @save="editing = false"
      @cancel="editing = false" />
  </div>
</div>
</template>

<script>
import { mapActions } from "vuex";
import MonitoramentoEditor from "./MonitoramentoEditor";
//import Confirm from "@/components/Dialog/Confirm";

export default {
  components: {
    MonitoramentoEditor,
    //Confirm,
  },
  props: {
    prestacaoConta: {
      type: Object,
      required: true,
    },
    papeis: {
      required: true,
    },

  },
  computed: {
    
    hasPermissionEdit() {
      var payload = {
        'prestacaoContaId': parseInt(this.$route.params.prestacaoContaId),
        'papeis': this.papeis,
        'permission': 'PERMISSION_MONITORAMENTO_FINANCEIRO_EDIT'
      }     
      return this.$store.getters["prestacaoConta/hasPermission"](payload)
    },
    hasPermissionView() {
      var payload = {
        'prestacaoContaId': parseInt(this.$route.params.prestacaoContaId),
        'papeis': this.papeis,
        'permission': 'PERMISSION_MONITORAMENTO_FINANCEIRO_VIEW'
      }     
      return this.$store.getters["prestacaoConta/hasPermission"](payload)
    },
    
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },
  },
  data () {
    return {
      editing: false,
    }
  },

  methods: {
    ...mapActions("prestacaoConta", ["proximaEtapa", "downloadArquivo"]),

    enviar() {
      var payload = {
        projetoId: this.$route.params.projetoId, 
        prestacaoContaId: this.$route.params.prestacaoContaId,
        enviarPara: 'enviar-manifestacao'
      }

      this.proximaEtapa(payload)
    },

    formatarData (data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    },
    
    getPayload() {
       return {
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.usuario.id
      }     
    },
    downloadItem() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        'arquivoId': this.prestacaoConta.arquivoMonitoramento.id
      }

      console.log(payload)
      this.downloadArquivo(payload)
    },    

  }
};
</script>

<style>
</style>
